import React, { useState, useContext, useEffect } from 'react';
import {IProps} from './types';
import Tooltip from '@components/Tooltip';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import { findCommonAttributeValue } from '@utils/editor'
import {ReactComponent as SubscriptIcon} from 'assets/svgs/subscript.svg';

const FontSubscriptCommandOption:React.FC<IProps> = (props) => {      
  let context = useContext(Context);
  const [isSelected, setIsSelected]= useState(false);

  useEffect(() => {
    const fontSubscript = findCommonAttributeValue(context.editorStatus.selectedElementsId, context.data, "subscript", "Text", context.editorStatus.textSelectionInformation);
    setIsSelected(fontSubscript===undefined?false:fontSubscript.toString()==="true");
  }, [context.editorStatus.selectedElementsId.length, context.editorStatus.selectedElementsId[0], context.data, context.editorStatus.textSelectionInformation]);

  const SetfontSubscript = () => {          
    setIsSelected(!isSelected);
    context.onCommandChange("subscript", !isSelected);
    //Superscript/subscript mutually exclusive
    if(!isSelected) {
      const notCommand = "superscript";
      const fontSuperscript = findCommonAttributeValue(context.editorStatus.selectedElementsId, context.data, notCommand, "Text", context.editorStatus.textSelectionInformation);
      const isSuperscript = fontSuperscript === undefined ? false : fontSuperscript.toString() === "true";
      if (isSuperscript) {
        context.onCommandChange(notCommand, isSelected);
      }
    }
  }
  
  return (
    <S.Root>
         <Tooltip tip={"Subscript"}>
        <S.ButtonContainer onClick={SetfontSubscript} isSelected={isSelected}>       
            <SubscriptIcon/>        
        </S.ButtonContainer>
        </Tooltip>
    </S.Root>
  );

}

export default FontSubscriptCommandOption;